<template>
    <div >
      <Header />
      <v-dialog persistent content-class="innerExPan" v-model="Loaderdialog"  id="innerExPan" >
        <v-row no-gutters>
          <v-col cols="12" sm="12" style="text-align:center">
            <img  :src="require('@/assets/images/loader.svg')"  />
          </v-col>
        </v-row>
      </v-dialog>
    
      <v-snackbar Bottom :timeout="timeout" :color="SnackbarColor"  v-model="snackbar">
        {{ SnackbarMessege }}
      </v-snackbar> 
    <v-container class="grey lighten-5 mb-6">
      
      <v-row no-gutters v-if="VoucherType==='GR'">
        <v-col cols="12"
          style="text-align:center;padding-bottom:0px;    border-bottom: 1px dashed #000;background: #cfcfcf4a;"
        >
          Goods Receipt
        </v-col>
      </v-row>
      <v-row no-gutters v-if="VoucherType==='SO'">
        <v-col cols="12"
          style="text-align:center;padding-bottom:0px;    border-bottom: 1px dashed #000;background: #cfcfcf4a;"
        >
          Sales Order
        </v-col>
      </v-row>
      <v-row no-gutters v-if="VoucherType==='PS'">
        <v-col cols="12"
          style="text-align:center;padding-bottom:0px;    border-bottom: 1px dashed #000;background: #cfcfcf4a;"
        >
          PhysicalStock
        </v-col>
      </v-row>
       <v-row no-gutters v-if="VoucherType==='S'">
        <v-col cols="12"
          style="text-align:center;padding-bottom:0px;    border-bottom: 1px dashed #000;background: #cfcfcf4a;"
        >
          Sales
        </v-col>
      </v-row>
       <v-row no-gutters v-if="VoucherType==='DN'">
        <v-col cols="12"
          style="text-align:center;padding-bottom:0px;    border-bottom: 1px dashed #000;background: #cfcfcf4a;"
        >
          Delivery Note
        </v-col>
      </v-row>
       <v-row no-gutters v-if="VoucherType==='P'">
        <v-col cols="12"
          style="text-align:center;padding-bottom:0px;    border-bottom: 1px dashed #000;background: #cfcfcf4a;"
        >
          Purchase
        </v-col>
      </v-row>
      <v-row no-gutters v-if="VoucherType==='LPO'">
        <v-col cols="12"
          style="text-align:center;padding-bottom:0px;    border-bottom: 1px dashed #000;background: #cfcfcf4a;"
        >
          LPO
        </v-col>
      </v-row>
      <v-row no-gutters>
        <div class="row" style="padding:5px;    font-size: 13px;">
          <div class="col" style="" @click="OpenVoucherMainDetailsModal()">
            <label  for=""
              >Number# : <b>{{VoucherDatas.Number}}</b></label
            ><br/>
            <label v-if="VoucherType ==='GR' || VoucherType ==='P' || VoucherType ==='LPO'" for=""
              >Supplier : <b>{{VoucherDatas.Title}}</b></label
            >
            <label v-if="VoucherType ==='SO' || VoucherType ==='S'||VoucherType ==='DN' " for=""
              >Customer : <b>{{VoucherDatas.Title}}</b></label
            >
            <label v-if="VoucherType ==='PS'" for=""
              >Warehouse : <b>{{VoucherDatas.Title}}</b></label
            >
          </div>
          <div class="col" style="text-align:right;" @click="OpenVoucherMainDetailsModal()">
            <label for=""
              >Date  : <b>{{VoucherDatas.Date}}</b></label
            ><br />
             <!-- <label for=""
              >Expiry Date  : <b>{{VoucherDatas.VoucherExpiryDate}}</b></label
            ><br /> -->
            <label for=""
              >Remarks : <b>{{VoucherDatas.Remarks}}</b></label
            >
          </div>
        </div>
      </v-row>
      <v-row no-gutters>
        <div
          class="col"
          style="text-align:center;padding-bottom:0px;    border-bottom: 1px dashed #000;background: #cfcfcf4a;"
        >
          Item Details
        </div>
      </v-row>
      <v-row no-gutters style="font-weight:normal;font-size: 15px;" @click="OpenVoucherDetailsModal()">
        <v-col class="col-1 pp2 text-left">Sl </v-col>
        <v-col class="col-4 pp2 text-left">Item Name </v-col>
        <v-col class="col-3 pp2 text-left">Barcode </v-col>
        <v-col class="col-3 pp2 text-right">Quantity </v-col>
        <v-col class="col-1 pp2 text-right"> </v-col>
      </v-row>
      <div
        class="scrl"
        style="padding-top:5px;text-align:left;font-size: 13px; font-weight:bold;"
      >
        <v-row no-gutters v-for="(item, i) in VoucherDetails" :key="i" @click="OpenVoucherDetailsModal">
          <v-col class="col-1 pp2 text-left">{{ i+1 }} </v-col>
          <v-col class="col-4 pp2 text-left">{{item.ItemName}} </v-col>
          <v-col class="col-3 pp2 text-left">{{item.Barcode}}</v-col>
          <v-col class="col-3 pp2 text-right">{{item.Quantity}}</v-col>
          <v-col class="col-1 pp2 text-right">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="#000"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  style="font-size: 19px;"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>

              <v-list>
                <v-list-item >
                  <v-icon style="font-size:22px;color: green;" @click="EditItem(i)">
                    mdi-pencil-circle
                  </v-icon>
                </v-list-item>
                <v-list-item >
                  <v-icon style="font-size:22px;color: red;" @click="DeleteItem(i)">
                    mdi-delete-circle
                  </v-icon>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </div>
      <v-container>
        <v-row>
          <v-bottom-navigation
            v-model="value"
            grow
            fixed
            bottom
            style="    box-shadow: none;"
          >
            <v-btn value="recent" @click="ClearAll()">
              <span>Clear All</span>

              <v-icon>mdi-reload</v-icon>
            </v-btn>
            <v-btn value="favorites" @click="OpenVoucherRegister">
              <span>Registers</span>

              <v-icon>mdi-view-list</v-icon>
            </v-btn>
            <!-- <v-btn value="upload" hidden>
              <span>Upload</span>

              <v-icon>mdi-cloud-upload</v-icon>
            </v-btn> -->

            <v-btn value="save" @click="SaveModal = true">
              <span>Save</span>

              <v-icon>mdi-content-save</v-icon>
            </v-btn>
            <v-btn value="add"  @click="OpenVoucherDetailsModal()">
              <span>Add</span>

              <v-icon>mdi-plus-box</v-icon>
            </v-btn>
          </v-bottom-navigation>
        </v-row>
        <v-bottom-sheet v-model="VoucherMainDetailsModal">
          <v-sheet class="text-center" height="350px" style="padding:10px;">
            <v-row style="border-bottom:1px dotted #000;" v-if="VoucherType==='GR'">
              <v-col cols="12">Goods Receipt</v-col>
            </v-row>
            <v-row style="border-bottom:1px dotted #000;" v-if="VoucherType==='SO'">
              <v-col cols="12">Sales Order</v-col>
            </v-row>
            <v-row style="border-bottom:1px dotted #000;" v-if="VoucherType==='PS'">
              <v-col cols="12">Physical Stock</v-col>
            </v-row>
             <v-row style="border-bottom:1px dotted #000;" v-if="VoucherType==='S'">
              <v-col cols="12">Sales</v-col>
            </v-row>
             <v-row style="border-bottom:1px dotted #000;" v-if="VoucherType==='DN'">
              <v-col cols="12">Delivery Note</v-col>
            </v-row>

            <v-row style="padding-left:10px;padding-right:10px;">
              <v-col cols="6"  style="padding-top: 14px;padding-bottom: 0px;">
                  <v-combobox
                    outlined
                  v-model="BranchCode"
                  :items="BranchCodeOptions"
                 label="Select Branch"
                 @change="GetBranchByBranchCode($event)"
                  :disabled="IsDisableBarnch"
                 dense
                ></v-combobox>
                </v-col>
              <v-col cols="6" style="padding-bottom: 0px;">
                <v-text-field
                 v-model="VoucherNo"
                  outlined
                  label="Voucher Number"
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="6" style="padding-bottom: 0px;padding-top: 0px;">
                <!-- <v-text-field
                v-model="Supplier"
                  label="Supplier"
                  outlined
              
                ></v-text-field> -->
                <v-combobox 
v-model="Title"
:items="SupplierOptions"
label="Supplier"
outlined
dense
v-if="VoucherType==='GR' || VoucherType==='P' || VoucherType==='LPO'"


></v-combobox>
<v-combobox 
v-model="Title"
:items="CustomerOptions"
label="Customer"
outlined
dense
v-if="VoucherType==='SO' || VoucherType==='S' || VoucherType==='DN'"


></v-combobox>
<v-combobox 
v-model="Title"
:items="GodownsOptions"
label="Warehouse"
outlined
dense
v-if="VoucherType==='PS'"


></v-combobox>
              </v-col>
         
              <v-col cols="6" style="padding-bottom: 0px;padding-top: 0px;">
                <v-text-field
               v-model="VoucherDate"
                  outlined
                  label="Date"
                  type="date"
                  dense
                ></v-text-field>
                
              
                
                  </v-col>
                    <!--<v-col cols="6" style="padding-bottom: 0px;padding-top: 0px;">
                <v-text-field
               v-model="VoucherExpiryDate"
                  outlined
                  label="Expiry Date"
                  type="date"
                  dense
                ></v-text-field>
                
              
                
                  </v-col>-->
              <v-col cols="12" style="padding-bottom: 0px;padding-top: 0px;">
                <v-textarea
              v-model="VoucherRemarks"
                  label="Remarks"
                  outlined
                  dense
                  rows="1"
                  auto-grow
                ></v-textarea>
              </v-col>
              <v-col cols="12" style="padding-top: 0px;"
                ><v-btn color="red" dark @click="CloseVoucherMainDetails()">
                  <v-icon> mdi-keyboard-backspace</v-icon> </v-btn
                >&nbsp;
                <v-btn color="warning" dark @click="ClearVoucher">
                  <v-icon>mdi-close-box</v-icon> </v-btn
                >&nbsp;
                <v-btn color="blue" dark @click="SaveVoucher">
                  <v-icon>mdi-checkbox-marked</v-icon>
                </v-btn></v-col
              >
            </v-row>
          </v-sheet>
        </v-bottom-sheet>

        <v-bottom-sheet v-model="VoucherDetailsModal" >
          <v-sheet class="text-center" height="370px" style="padding:10px;">
            <v-row style="border-bottom:1px dotted #000;">
              <v-col cols="12">Add Item</v-col>
              <v-col cols="6" style="padding-top:0px;padding-bottom:0px;margin-bottom: -30px;">
                <v-checkbox
                  style="margin-top: 0px; padding-top: 0px;"
                  v-model="AlwaysopenBarcodeScan"
                  label="Always open cam scanner"
               
                ></v-checkbox>
              </v-col>
            <v-col cols="6" style="padding-top:0px;padding-bottom:0px;margin-bottom: -30px;padding-right: 16px;text-align: right;" @click="PriceGroupmodal=true">
              Rate : <label style="color: #2196F3;">{{RetailRate}}</label>
            </v-col>
            <v-col cols="6" style="padding-top:0px;padding-bottom:0px;margin-bottom: -10px;">
               <v-switch
             v-model="IsBarcodeScan"
      @change="SetFocusOnItemCode"
      label="Barcode Scan"
    ></v-switch>
              </v-col>
              <v-col  v-if="VoucherType==='GR'" cols="6" style="padding-bottom: 0px;padding-top: 13px;">
                <v-text-field
               v-model="ExpiryDate"
                  outlined
                  label="Expiry Date"
                  type="date"
                  dense
                ></v-text-field>
                
              
                
                  </v-col>
              
            </v-row>
            <v-row style="padding-left:10px;padding-right:10px;">
              <v-col cols="6">
                <v-text-field
                v-model="Barcode"
                  outlined
                  id="ebar"
                  autofocus
                  label="Barcode"
                  append-icon="mdi-barcode"
                  @keyup.enter="moveToNext2()"
                  @change="GetItemNameByBarcode()"
                  @click:append="OpenBarcodeReader"
                  v-if="IsBarcodeScan === true"
                ></v-text-field>
                      <v-text-field
                  v-model="ItemCode"
                  outlined
                  id="eitemcode"
                  autofocus
                  label="ItemCode"
                  append-icon="mdi-barcode"
                  @keyup.enter="moveToNext2()"
                  @change="GetItemNameByItemCode()"
                  @click:append="OpenBarcodeReader"
                  v-if="IsBarcodeScan === false"
               
                ></v-text-field>
               
              </v-col>
              
              <v-col cols="6">
                <v-text-field
                  ref="b_quantity"
                  id="quantity"
                  v-model="Quantity"
                  label="Quantity"
                  type="number"
                  @keyup.enter="AddItem"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row
              style="padding-left:10px;padding-right:10px;margin-top: -30px;"
            >
              <v-col cols="12" style="padding-bottom: 0px;
    margin-bottom: -13px;">
                <v-text-field
                  @keyup.enter="AddItem"
                  id="iname"
                  label="Item Name"
                   v-model="ItemName"
              
                  outlined
                ></v-text-field>
               <!--  <v-combobox
                  v-model="ItemName"
                  :items="ItemOptions"
                  :label="'Item Name'"
                  outlined
                  @change="GetItemByItemId()"
                  ></v-combobox> -->
               
              </v-col>
            </v-row>
            <v-row  style="justify-content: center;" class="mt-0">
            </v-row>
         
            <v-row >
              <v-col cols="12">
                <v-btn color="red" dark @click="closeVoucherDetailsModal()">
                  <v-icon> mdi-keyboard-backspace</v-icon> </v-btn
                >&nbsp;
                <v-btn color="warning" dark @click="ClearVoucherDetailsModal()">
                  <v-icon>mdi-close-box</v-icon> </v-btn
                >&nbsp;
                <v-btn color="blue" dark @click="AddItem()">
                  <v-icon>mdi-checkbox-marked</v-icon>
                </v-btn>
              </v-col></v-row
            >
          </v-sheet>
        </v-bottom-sheet> 

        <v-bottom-sheet v-model="VoucherDetailsModalEdit" >
          <v-sheet class="text-center" height="350px" style="padding:10px;">
            <v-row style="border-bottom:1px dotted #000;">
              <v-col cols="12">Add Item</v-col>
              <v-col cols="12" style="padding-top:0px;padding-bottom:0px;margin-bottom: -30px;">
                <v-checkbox
                  style="margin-top: 0px; padding-top: 0px;"
                  v-model="AlwaysopenBarcodeScan"
                  label="Always open cam scanner"
               
                ></v-checkbox>
              </v-col>
                 <v-col cols="6" style="padding-top:0px;padding-bottom:0px;margin-bottom: -10px;">
               <v-switch
       v-model="IsBarcodeScan"
      @change="SetFocusOnItemCode"
      label="Barcode Scan"
    ></v-switch>
              </v-col>
            <v-col  v-if="VoucherType==='GR'" cols="6" style="padding-bottom: 0px;padding-top: 13px;">
                <v-text-field
               v-model="ExpiryDate"
                  outlined
                  label="Expiry Date"
                  type="date"
                  dense
                ></v-text-field>
                
              
                
                  </v-col>
            </v-row>
            <v-row style="padding-left:10px;padding-right:10px;">
              <v-col cols="6">
                <v-text-field
                v-model="Barcode"
                  outlined
                  id="ebar"
                  autofocus
                  label="Barcode"
                  append-icon="mdi-barcode"
                  @keyup.enter="moveToNext2()"
                  @change="GetItemNameByBarcode()"
                  @click:append="OpenBarcodeReader"
                  v-if="IsBarcodeScan === true"
                ></v-text-field>
                
                  <v-text-field
                  v-model="ItemCode"
                  outlined
                  id="eitemcode"
                  autofocus
                  label="ItemCode"
                  append-icon="mdi-barcode"
                  @keyup.enter="moveToNext2()"
                  @change="GetItemNameByItemCode()"
                  @click:append="OpenBarcodeReader"
                  v-if="IsBarcodeScan === false"
               
                ></v-text-field>
               
              </v-col>
              <v-col cols="6">
                <v-text-field
                  ref="b_quantity"
                  id="quantity"
                  v-model="Quantity"
                  label="Quantity"
                  type="number"
                  @keyup.enter="UpdateItem"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row
              style="padding-left:10px;padding-right:10px;margin-top: -30px;"
            >
              <v-col cols="12" style="padding-bottom: 0px;
    margin-bottom: -13px;">
                <v-text-field
                  @keyup.enter="UpdateItem"
                  id="iname"
                  label="Item Name"
                   v-model="ItemName"
              
                  outlined
                ></v-text-field>
                <!-- <v-combobox
                  v-model="ItemName"
                  :items="itemoptions"
                  :label="'Item Name'"
                  outlined

                  ></v-combobox> -->
               
              </v-col>
            </v-row>
            <v-row  style="justify-content: center;" class="mt-0">
            </v-row>
         
            <v-row >
              <v-col cols="12">
                <v-btn color="red" dark @click="VoucherDetailsModalEdit = false">
                  <v-icon> mdi-keyboard-backspace</v-icon> </v-btn
                >&nbsp;
                <v-btn color="warning" dark @click="ClearVoucherDetailsModal()">
                  <v-icon>mdi-close-box</v-icon> </v-btn
                >&nbsp;
                <v-btn color="blue" dark @click="UpdateItem()">
                  <v-icon>mdi-checkbox-marked</v-icon>
                </v-btn>
              </v-col></v-row
            >
          </v-sheet>
        </v-bottom-sheet> 
      </v-container>
    </v-container>

    <v-dialog v-model="BarcodeModal" persistent width="500">
      <v-card>
        <v-card-title
          style="color:rgb(0 99 145);font-size:17px;text-align:center"
          >Scan barcode</v-card-title
        >

        <v-card-text>
          <StreamBarcodeReader
            @decode="a => onDecode(a)"
            @loaded="() => onLoaded()"
          ></StreamBarcodeReader>
        </v-card-text>
        <v-card-actions hidden>
          <v-spacer></v-spacer>
          <v-btn
            small
            @click="BarcodeModal = false"
            style="background-color:#FB8C00;color:#FFF"
          >
            Cancel
          </v-btn>

          <v-btn
            small
            @click="BarcodeModal = false"
            style="background-color:#2E7D32;color:#FFF"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

     <v-dialog v-model="DeleteModal" persistent width="300">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" style="padding-top: 45px;">
              <span style="font-size: 20px;">Do you want to delete?</span>
            </v-col>
            <v-col cols="12">
            <v-divider></v-divider>
            </v-col>
            <v-col cols="6" style="text-align: center;">
              <v-btn
            small
            @click="DeleteModal = false"
            style="background-color:#FB8C00;color:#FFF"
          >
            Cancel
          </v-btn>
              </v-col>
              <v-col cols="6" style="text-align: center;">
                <v-btn
            small
            @click="ExcecuteDeleteItem()"
            style="background-color:#2E7D32;color:#FFF"
          >
            ok
          </v-btn>
              </v-col>

          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="SaveModal" persistent width="300">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" style="padding-top: 45px;">
              <span style="font-size: 20px;">Do you want to save?</span>
            </v-col>
            <v-col cols="12">
            <v-divider></v-divider>
            </v-col>
            <v-col cols="6" style="text-align: center;">
              <v-btn
            small
            @click="SaveModal = false"
            style="background-color:#FB8C00;color:#FFF"
          >
            Cancel
          </v-btn>
              </v-col>
              <v-col cols="6" style="text-align: center;">
                <v-btn
            small
           @click="SaveVoucherRegister()"
            style="background-color:#2E7D32;color:#FFF"
          >
            ok
          </v-btn>
              </v-col>

          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
        <v-dialog v-model="PriceGroupmodal" persistent width="500">
      <v-card>
    

        <v-card-text style="padding: 0px;">
         
   <v-expansion-panels>

    <v-expansion-panel
      v-for="(item,i) in 1"
      :key="i"
      style="padding-left: 10px;"
    >
      <v-expansion-panel-header    style="text-align:center !important;min-height: 24px !important;" expand-icon="" >
          <v-row >
           <v-col cols="10" sm="10" style="padding-left: 0px !important; text-align: left !important;padding-top: 10px;">
       <b style="text-align:center !important; text-transform:uppercase;font-size:12px;color:#007bff;">Price Details</b>
      </v-col>
      <v-col cols="2" sm="2" style="padding: 0px !important; text-align: right !important;padding-top: 5px;">
        <v-icon @click="PriceGroupmodal=false" style="color: green;">mdi-close-box</v-icon>

      </v-col>
      </v-row>
        </v-expansion-panel-header>
    </v-expansion-panel>
  </v-expansion-panels >

     <v-card-actions style="background:#007bff;padding: 1px;">  </v-card-actions>


     <v-row no-gutters style="    font-size: 10px;padding: 5px; background: #343a402e;"  >
      <v-col cols="9" sm="9" class="text-left" style="padding-left: 5px;" >
       <label>Unit</label> 
      </v-col>
          <v-col cols="3" sm="3" class="text-right" style="padding-right: 12px;">
<label>Retail Rate</label> 
      </v-col>

    </v-row>

       <v-expansion-panels >

    <v-expansion-panel v-for="(item,i) in 3"  :key="i" class="ma-0" v-touch:tap="touchHandler" >
       <!-- ----- -->
     <v-expansion-panel-header expand-icon=""  style="min-height:35px !important;font-size:10px!important">

       <v-row >
       <v-col cols="9" sm="9"  style="padding-left: 0px; " >

   <b >PCS</b>
      </v-col>

       <v-col cols="3" sm="3" style="padding-right: 0px !important; text-align:right">
<label>165.000</label>
      </v-col>
      </v-row>


      </v-expansion-panel-header>
    </v-expansion-panel>
  </v-expansion-panels>


        </v-card-text>
      </v-card>

    </v-dialog>
   <v-dialog
      v-model="ItemCodeModal"
      persistent
      max-width="600"
      style="z-index: 10000000!important;"
    >
      <v-card style="padding-top:20px">
        <v-card-text>
          <v-row>
            <v-col cols="10" style="font-size: 18px;padding-top: 5px;
    padding-bottom: 18px;color: #000;">
              <label>Please select Item</label>
            </v-col>
            <v-col cols="2" style="text-align: right;padding-top: 5px;
    padding-bottom: 20px;color: #000;">
              <v-icon @click="ItemCodeModal=false" style="color: #000;">mdi-close-circle</v-icon>
            </v-col>
          </v-row>
        <Itemcodescan  :ItemUnitsObject="ItemUnitsObject"   @data-transmitted="handleEventEmail"/>
        </v-card-text>
     
      </v-card>
    </v-dialog>

      <v-dialog v-model="UploadModal" persistent width="300">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" style="padding-top: 45px;">
              <span style="font-size: 20px;">Should the voucher be uploaded?</span>
            </v-col>
            <v-col cols="12">
            <v-divider></v-divider>
            </v-col>
            <v-col cols="6" style="text-align: center;">
              <v-btn
            small
            @click="UploadVoucher(false)"
            style="background-color:#FB8C00;color:#FFF"
          >
            Cancel
          </v-btn>
              </v-col>
              <v-col cols="6" style="text-align: center;">
                <v-btn
            small
            @click="UploadVoucher(true)"
            style="background-color:#2E7D32;color:#FFF"
          >
            ok
          </v-btn>
              </v-col>

          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    </div>
    </template>
    <script>
    import axios from "axios";
    import Header from "./Header.vue";
    import { StreamBarcodeReader } from "vue-barcode-reader";
    import Itemcodescan from "./Itemcodescan.vue"
    export default {
      components: {
      Header,StreamBarcodeReader,Itemcodescan
    },
      data() {
        return {
          snackbar: false,
    SnackbarMessege: '',
     SnackbarColor:'green',
    timeout: 2000,
         headers : {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + localStorage.getItem('Token')
              },
            showsupplierDropdown:false,
            VoucherMainDetailsModal: false,
            showitemDropdown:false,
            edit_: false,
            BarcodeModal: false,
            DeleteModal:false,
            itemaddmodal:false,
            VoucherDetailsModal: false,
            VoucherDetailsModalEdit:false,
            UpdateId  : -1,
            DeleteId : -1,
             isLoading: true,
             Loaderdialog:false,
             VoucherDatas:
             {
              "Number" : "",
              "Title" : "",
              "Date" : new Date().toISOString().substr(0, 10),
              "BranchCode" : "",
              "VoucherExpiryDate" : new Date().toISOString().substr(0, 10),
              "Remarks" : ""
             },
             VoucherNo : "",
             Title : "",
             VoucherDate : new Date().toISOString().substr(0, 10),
             VoucherExpiryDate : new Date().toISOString().substr(0, 10),
             ExpiryDate : new Date().toISOString().substr(0, 10),
             VoucherRemarks : "",
             VoucherDetails : [],
             SupplierOptions : [],
             CustomerOptions:[],
             GodownsOptions:[],
             bURL : localStorage.getItem('BaseURL'),
             Currency:localStorage.getItem('Currency'),
             DecimalPlaces : localStorage.getItem('symbol'),
             ItemName:"",
             Barcode : "",
             Quantity : "",
             RetailRate : 0,
             AlwaysopenBarcodeScan:false,
             ItemObject:[],
             ItemOptions:[],
             Registers:[],
             SaveModal:false,
             VoucherEditId:-1,
             VoucherType : localStorage.getItem('VoucherType'),
             PriceGroupId :  localStorage.getItem("PriceGroupId")?localStorage.getItem("PriceGroupId"):0,
             BranchCodeOptions :JSON.parse(localStorage.getItem('Branches')),
             BranchCode : "MB",
             IsDisableBarnch : false,
             PriceGroupmodal:false,
             IsNativeFlutterApp : true,
             ItemCodeModal:false,
             IsBarcodeScan : true,
             ItemUnitsObject : [],
             UploadModal:false,
             OrderNextNoFinal : 0
        };
      },
      watch: {
      
      },
    
      mounted() {
        this.Token = localStorage.getItem('Token')
      if (this.Token === "" || this.Token === null || this.Token === undefined ) 
       {
        this.$router.push("login");
       }
        this.VoucherEditId = localStorage.getItem('VoucherEditId')
       
        if(this.VoucherEditId !== null && this.VoucherEditId !== undefined)
        {
          this.VoucherEditId = parseInt(this.VoucherEditId)
          this.Registers = [];
          if (localStorage.getItem("VoucherRegister") != null) {
            this.Registers = JSON.parse(localStorage.getItem("VoucherRegister"));
          }
          if(this.Registers.length > 0)
          {
            this.VoucherDatas.Number = this.Registers[this.VoucherEditId].VoucherNo
            this.VoucherDatas.Date = this.Registers[this.VoucherEditId].VoucherDate
            this.VoucherDatas.BranchCode = this.Registers[this.VoucherEditId].BranchCode
            this.VoucherDatas.VoucherExpiryDate = this.Registers[this.VoucherEditId].VoucherExpiryDate
            this.VoucherDatas.Remarks = this.Registers[this.VoucherEditId].Remarks
            this.VoucherDatas.Title = this.Registers[this.VoucherEditId].Title
            this.VoucherDetails = this.Registers[this.VoucherEditId].VoucherDetails
          }
        }
        if(this.VoucherType === "GR" || this.VoucherType === "LPO" || this.VoucherType === "P")
        {
          this.GetSuppliers()
        }
        else if(this.VoucherType === "SO" || this.VoucherType === "S" || this.VoucherType === "DN" ){
          this.GetCustomers()
        }
        else if(this.VoucherType === "PS")
        {
          this.GetGodowns()
        }
        
          this.IsNativeFlutterApp = localStorage.getItem("IsNativeFlutterApp");
        if (this.IsNativeFlutterApp === "true" || this.IsNativeFlutterApp === true)
        {
          this.IsNativeFlutterApp = true
        }
        else
        {
          this.IsNativeFlutterApp = false
        }
        this.GetItems()
         
        
            this.BranchCode = localStorage.getItem('SystemBranch')
            if(this.BranchCode === "#" || this.BranchCode === "" || this.BranchCode === "null" || this.BranchCode === null ||this.BranchCode === undefined)
            {
              this.BranchCode = ""
            }
            this.VoucherDatas.BranchCode = this.BranchCode
          this.UserDetails = JSON.parse(localStorage.getItem('User'))
          this.BranchCode1 = this.UserDetails.BranchCode
          
          if(this.UserDetails.userType === "Administrator" || (this.UserDetails.userType !== "Administrator" && (this.BranchCode1 === "#" || this.BranchCode1 === "" || this.BranchCode1 === "null" || this.BranchCode1 === null)))
          {
            this.IsDisableBarnch = false
          }
          else{
            this.IsDisableBarnch = true
          }
        this.GetInvoiceNo()
         
      },
      methods:
      {
        GetSuppliers()
        {
          this.SupplierOptions = []
          axios.get(this.bURL + '/api/Supplier/LoadSuppliersBy?BranchCode=' + this.BranchCode)
          .then((response)  =>  {
            this.SupplierOptions = []
            for(this.i=0;this.i<response.data.length;this.i++)
            {
                this.SupplierOptions.push(response.data[this.i].SuppName)
            }
          }, (error)  =>  {
             console.log(error)
          })
        },
        GetGodowns()
        {
          axios.get(this.bURL + '/api/godown/GetGodownsBy?BranchCode=' +this.BranchCode+ "&ActiveStatus=Active")
          .then((response)  =>  {
              this.GodownsOptions = response.data
          }, (error)  =>  {
             console.log(error)
          })
        },
        GetCustomers()
        {
          this.Salesperson = window.localStorage.getItem('user');
          axios.get(this.bURL + '/api/Customer/LoadCustomerByBranch?BranchCode=' + this.BranchCode)
          .then((response)  =>  {
              this.CustomerOptions = response.data
          }, (error)  =>  {
             console.log(error)
          })
        },
        GetItems()
        {
          
          axios.get( this.bURL + '/api/Item/GetItemsBy?ItemType=2' )
          .then((response)  =>  {
              this.ItemObject = response.data
              for(this.i=0;this.i<this.ItemObject.length;this.i++)
              {
                this.ItemOptions.push(this.ItemObject[this.i].itemName)
              }
          }, (error)  =>  {
             console.log(error)
          })
        },
        OpenVoucherMainDetailsModal()
        {
          this.VoucherNo = this.VoucherDatas.Number
          this.Title = this.VoucherDatas.Title
          this.VoucherDate = this.VoucherDatas.Date
          this.BranchCode = this.VoucherDatas.BranchCode
          this.VoucherExpiryDate = this.VoucherDatas.VoucherExpiryDate
          this.VoucherRemarks = this.VoucherDatas.Remarks
          this.VoucherMainDetailsModal = true
          this.VoucherDetailsModalEdit = false
        },
        CloseVoucherMainDetails()
        {
            this.ClearVoucher()
            this.VoucherMainDetailsModal = false
            
        },
        ClearVoucher()
        {
          this.VoucherNo = ""
          this.Title= ""
          this.VoucherDate = new Date().toISOString().substr(0, 10)
          this.VoucherExpiryDate = new Date().toISOString().substr(0, 10)
          this.VoucherRemarks = ""
        },
        SaveVoucher()
        {
             this.VoucherDatas.Number = this.VoucherNo
             this.VoucherDatas.Title = this.Title
             this.VoucherDatas.Date = this.VoucherDate
             this.VoucherDatas.BranchCode = this.BranchCode
             this.VoucherDatas.VoucherExpiryDate = this.VoucherExpiryDate
             this.VoucherDatas.Remarks = this.VoucherRemarks
             this.CloseVoucherMainDetails()
        },
    GetBranchByBranchCode()
    {
      this.Loaderdialog = true
      axios
          .get(this.bURL+"/api/Branch/GetBranchByBranchCode?BranchCode=" +
            this.BranchCode )
          .then(
            (response) => {
              this.Loaderdialog = false
              this.PriceGroupId = response.data.PriceGroupId
              this.GetGodowns()
               if(this.VoucherType === "P" || this.VoucherType === "LPO" || this.VoucherType === "PR" || this.VoucherType === "GR")
               {
                this.GetSuppliers()
               }
               else if(this.VoucherType === "SO" || this.VoucherType === "S" || this.VoucherType === "DN" ){
                 this.GetCustomers()
               }
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );
    },
        scanbarcode() {
      //alert("aaa");
      this.BarcodeModal = true;
    },
     OpenBarcodeReader()
    {
      this.IsCamera = false
          if (this.IsNativeFlutterApp === true) {
            //window.FromJavascriptScanner.postMessage('CamaraLaunchRequist');
            this.OpenBarcodeReaderFlutter()
          } 
          else
          {
             this.BarcodeModal = true
          }
    },
   
    OpenBarcodeReaderFlutter() {
      // Call the Flutter handler to launch the barcode scanner
      window.flutter_inappwebview.callHandler('CamaraLaunchRequist')
        .then((result) => {
          if (result) {
            // Handle the barcode result
            //console.log('Barcode scanned:', result);
            //this.GetItemByBarcode(result)
            this.Barcode = result
             if(this.IsBarcodeScan === true)
             {
                this.Barcode = result
                this.GetItemNameByBarcode()
            }
            else{
              this.ItemCode = result
              this.GetItemNameByItemCode()
            }
        this.BarcodeModal = false;
        this.moveToNext('quantity');

          } else {
            console.log('Barcode scanning cancelled or failed');
          }
        })
        .catch((error) => {
          console.error('Error launching barcode scanner:', error);
        });
    },
        
      GetItemNameByBarcode()
      {
          axios.get(this.bURL + "/api/item/getitembybarcode?barcode=" + this.Barcode + "&PriceGroupId=" + this.PriceGroupId)
          .then((response)  =>  {
              this.ItemName = response.data.ItemName
              this.RetailRate = response.data.RetailRate
              this.RetailRate =  this.FormatewithDecimalPlacesNew(this.RetailRate)
          }, (error)  =>  {
             console.log(error)
          })  
      },
      GetItemNameByItemCode()
      {
          this.Loaderdialog = true
          axios.get(this.bURL + "/api/item/SelectItemByItemCodeDetailed?ItemCode=" + this.ItemCode + "&PriceGroupId=0" )
          .then((response)  =>  {
             this.Loaderdialog = false
             this.ItemUnitsObject = response.data
             if(this.ItemUnitsObject.length > 1)
             {
                for(this.i = 0;this.i<this.ItemUnitsObject.length;this.i++)
                {
                  this.ItemUnitsObject[this.i].IsSelected = false
                }
                  this.ItemCodeModal = true
             }
             else{
              this.handleEventEmail(0)
             }
             /*  this.ItemName = response.data.ItemName
              this.ItemCode = response.data.ItemCode
              this.AltUnitId = response.data.AltUnitId
              this.Unit = response.data.Unit
              this.VerifiedItemModal=true
              this.VerifyItem() */
               setTimeout(() => {
                  this.moveToNext2()
              }, 200);
             
          }, (error)  =>  {
             this.Loaderdialog = false
             this.SnackbarColor = 'red'
             this.timeout = 3000
             this.SnackbarMessege = "Item does not exist"
             this.snackbar = true
          })  
      },
      
    handleEventEmail(Id) {

      this.ItemName = this.ItemUnitsObject[Id].ItemName
      this.Barcode = this.ItemUnitsObject[Id].Barcode
      this.ItemCode = this.ItemUnitsObject[Id].ItemCode
      this.AltUnitId =this.ItemUnitsObject[Id].AltUnitId
      this.RetailRate =this.ItemUnitsObject[Id].RetailRate
      this.RetailRate =  this.FormatewithDecimalPlacesNew(this.RetailRate)
      this.Unit = this.ItemUnitsObject[Id].Unit
      this.ItemCodeModal = false
       setTimeout(() => {
                  this.moveToNext2()
              }, 200);
    },
      SetFocusOnItemCode()
      {
        if(this.IsBarcodeScan === true)
        {
           setTimeout(() => {
                 document.getElementById('ebar').focus();
              }, 200);
        }
        else{
           setTimeout(() => {
                document.getElementById('eitemcode').focus();
              }, 200);
          
        }  
      },
      FormatewithDecimalPlacesNew(value) {
      this.number = localStorage.getItem("symbol");
      let val = (value / 1).toFixed(this.number).replace(".", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      
    },
    onDecode(a) {
      console.log("Result Barcode " + a);
      // this.text = a;
      if (a != null || a != "") {
        this.Barcode = a;
        if(this.IsBarcodeScan === true)
        {
          this.Barcode = a;
          this.GetItemNameByBarcode()
        }
        else{
          this.ItemCode = a;
          this.GetItemNameByItemCode()
        }
        this.BarcodeModal = false;
        this.moveToNext('quantity');
     }
    },
    moveToNext2() {
    
    const nextField = document.getElementById('quantity'); // Get the next field
    nextField.focus(); // Move focus to the next field
  
    },
    moveToNext(nextFieldId) {
      const currentField = document.activeElement; // Get the current active field
      if (currentField.value.length > 0) {
      const nextField = document.getElementById(nextFieldId); // Get the next field
      nextField.focus(); // Move focus to the next field
  }
  },
  OpenVoucherDetailsModal()
  {
    this.ClearVoucherDetailsModal()
    this.VoucherDetailsModal = true;
  },
  closeVoucherDetailsModal() {
    this.VoucherDetailsModal = false;
  },
  ClearVoucherDetailsModal() {
    this.ItemCode = ""
    this.ItemName = ""
    this.Barcode = ""
    this.Quantity = ""
    this.RetailRate = ''
    this.ExpiryDate = new Date().toISOString().substr(0, 10)
  },
  AddItem() {
    this.Quantity = parseFloat(this.Quantity)
    this.flag = isNaN(this.Quantity)
    if(this.flag === true)
    {
      this.Quantity = ""
    }
      if (this.Barcode == "") {
        this.SnackbarColor = 'orange'
        this.timeout = 2000
        this.SnackbarMessege = "Enter Barcode"
        this.snackbar = true;
        document.getElementById("ebar").focus();
       
      }
      else if (this.Quantity == "") {
        this.SnackbarColor = 'orange'
        this.timeout = 2000
        this.SnackbarMessege = "Enter Quantity"
        this.snackbar = true;
        document.getElementById("quantity").focus();
       
      }
       else {
        this.obj = {
          "Barcode"  : this.Barcode,
          "ItemName" : this.ItemName,
          "Quantity" : this.Quantity,
          'ExpiryDate' : this.ExpiryDate,
          "Remarks" : ""
        }
        this.VoucherDetails.push(this.obj);
        //localStorage.setItem("VoucherDetails", JSON.stringify(this.VoucherDetails));
        this.ClearVoucherDetailsModal()
        if (this.AlwaysopenBarcodeScany == true) {
          this.BarcodeModal = true;
        }
        else{
          document.getElementById("ebar").focus();
        }
      }

    },
    EditItem(index)
    {
      this.UpdateId = index
         this.ItemName = this.VoucherDetails[index].ItemName
         this.Barcode = this.VoucherDetails[index].Barcode
         this.Quantity = this.VoucherDetails[index].Quantity
         this.ExpiryDate = this.VoucherDetails[index].ExpiryDate
         this.VoucherDetailsModalEdit = true
    },
    UpdateItem()
    {
      this.Quantity = parseFloat(this.Quantity)
    this.flag = isNaN(this.Quantity)
    if(this.flag === true)
    {
      this.Quantity = ""
    }
      if (this.Barcode == "") {
        this.SnackbarColor = 'orange'
        this.timeout = 2000
        this.SnackbarMessege = "Enter Barcode"
        this.snackbar = true;
        document.getElementById("ebar").focus();
       
      }
      else if (this.Quantity == "") {
        this.SnackbarColor = 'orange'
        this.timeout = 2000
        this.SnackbarMessege = "Enter Quantity"
        this.snackbar = true;
        document.getElementById("quantity").focus();
       
      }
       else {
        this.VoucherDetails[this.UpdateId].ItemName = this.ItemName
        this.VoucherDetails[this.UpdateId].Barcode = this.Barcode
        this.VoucherDetails[this.UpdateId].Quantity = this.Quantity
        this.VoucherDetails[this.UpdateId].ExpiryDate = this.ExpiryDate
       }
       this.VoucherDetailsModalEdit = false
    },
    DeleteItem(index)
    {
      this.DeleteId = index
      this.DeleteModal=true
    },
    ExcecuteDeleteItem()
    {
      this.VoucherDetails.splice(this.DeleteId,1)
      this.DeleteModal=false
    },

    SaveVoucherRegister() {
      this.TitleName = ""
      if(this.VoucherType === "SO" || this.VoucherType === "S" || this.VoucherType === "DN")
      {
          this.TitleName = "Customer"
      }
      if(this.VoucherType === "P" || this.VoucherType === "LPO" || this.VoucherType === "PR" || this.VoucherType === "GR")
      {
          this.TitleName = "Supplier"
      }
      
      if (this.VoucherDatas.BranchCode === undefined || this.VoucherDatas.BranchCode == null || this.VoucherDatas.BranchCode== "") {
         this.SnackbarColor = 'orange'
         this.timeout = 2000
         this.SnackbarMessege= "Please Select branch code"
         this.snackbar = true;
    
      }
     if (this.VoucherDatas.Number == null || this.VoucherDatas.Number== "") {
         this.SnackbarColor = 'orange'
         this.timeout = 2000
         this.SnackbarMessege= "Please Enter Voucher Number"
         this.snackbar = true;
         return
    
      }
      else if (this.VoucherDatas.Title == null || this.VoucherDatas.Title== "") {
         this.SnackbarColor = 'orange'
         this.timeout = 2000
         this.SnackbarMessege= "Please Select " + this.TitleName
         this.snackbar = true;
         return
    
      }
      else if(this.VoucherDetails.length < 1)
      {
        this.SnackbarColor = 'orange'
        this.timeout = 2000
         this.SnackbarMessege = "Please Add Atleast one item"
         this.snackbar = true;
         return
      } 
      else
      {

      this.Registers = [];
      if (localStorage.getItem("VoucherRegister") != null) {
        this.Registers = JSON.parse(localStorage.getItem("VoucherRegister"));
      }
      const myobj = {
        // VoucherId: 0,
        VoucherType: this.VoucherType,
        VoucherNo: this.VoucherDatas.Number,
        Title: this.VoucherDatas.Title,
        VoucherDate: this.VoucherDatas.Date,
        BranchCode: this.VoucherDatas.BranchCode,
        VoucherExpiryDate : this.VoucherDatas.VoucherExpiryDate,
        Remarks: this.VoucherDatas.Remarks,
        UploadStatus: false,
        VoucherDetails: this.VoucherDetails
      };
      myobj.IsFromVerify = false
      if(this.VoucherEditId !== null && this.VoucherEditId !== undefined && this.VoucherEditId !== -1)
      {
        this.Registers[this.VoucherEditId] = myobj
      }
      else
      {
        this.Registers.push(myobj);
      }
      
      this.UploadObject = myobj
      localStorage.setItem("VoucherRegister", JSON.stringify(this.Registers));
      this.SaveModal = false
      if(this.VoucherType === "SO" && this.OrderNextNoFinal > 0 )
      {
        this.OrderNextNoFinal += 1
        localStorage.setItem("OrderNextNo", this.OrderNextNoFinal);
        this.GetInvoiceNo()
      }
      this.UploadModal = true
      
       
      }
    },
    UploadVoucher(IsUpload)
    {
         if(IsUpload === true)
         {
           this.ExcecuteUpload()
         }
         else{
           this.ClearAll()
           this.SnackbarColor = 'green'
           this.timeout = 2000
           this.SnackbarMessege = "Saved"
           this.snackbar = true;
           this.UploadModal = false
         }
    },
    ExcecuteUpload()
    {
      this.Loaderdialog = true
        axios.post(this.bURL + '/api/PDTvoucher',this.UploadObject,
          {
                headers: this.headers
          })
          .then((response)  =>  {
               this.VoucherRegister = localStorage.getItem("VoucherRegister")
               if(this.VoucherRegister !== null)
               {
                 this.VoucherRegister = JSON.parse(this.VoucherRegister)
               }
               this.VoucherRegister[this.VoucherRegister.length-1].UploadStatus = true
               localStorage.setItem('VoucherRegister',JSON.stringify(this.VoucherRegister))
              this.Loaderdialog = false

              this.ClearAll()
              this.SnackbarColor = 'green'
              this.timeout = 2000
              this.SnackbarMessege = "Saved"
              this.snackbar = true;
              this.UploadModal = false
            
          },
           (error)  =>  {
          this.isLoading = false
          this.isSignInDisabled = false
          this.timeout = 3000
          this.SnackbarColor = 'red'
          if(error.response === undefined)
          {
            this.SnackbarMessege = this.$t(`menu.CheckyourInternetConnection`)
          }
          else if(error.response.data !=="")
          {
            this.SnackbarMessege = error.response.data
          }
          else if(error.response.status === 401)
          {
             this.GlobalPasswordModal = true
          }
           else{
             this.SnackbarMessege = this.$t(`menu.CheckyourInternetConnection`)
           }
          this.snackbar = true
        })
    },
    ClearAll()
    {
      this.ClearVoucher()
      this.VoucherEditId = -1
      localStorage.removeItem('VoucherEditId')
      this.VoucherDatas =
             {
              "Number" : "",
              "Title" : "",
              "Date" : new Date().toISOString().substr(0, 10),
               "VoucherExpiryDate" : new Date().toISOString().substr(0, 10),
              "Remarks" : ""
             },
      this.VoucherDetails = []
      this.GetInvoiceNo()
    },
  OpenVoucherRegister() {
      this.$router.push("VoucherRegister");
    },
    GetInvoiceNo()
    {
       if(this.VoucherType === "SO")
         {
           this.OrderPrefix = localStorage.getItem('OrderPrefix')?localStorage.getItem('OrderPrefix'): ""
           this.OrderNextNo = localStorage.getItem('OrderNextNo')?localStorage.getItem('OrderNextNo'): ""
           this.OrderSuffix = localStorage.getItem('OrderSuffix')?localStorage.getItem('OrderSuffix'): ""
           this.OrderNextNoFinal = parseFloat(this.OrderNextNo)
           this.OrderNoFlag = isNaN(this.OrderNextNoFinal)
           if(this.OrderNoFlag === true)
           {
             this.OrderNextNoFinal = 0
           }
            if(this.OrderNextNo !=="" && this.OrderNextNo !== null && this.OrderNextNo !== undefined)
            {
             this.VoucherNo = this.OrderPrefix + this.OrderNextNo +this.OrderSuffix
             this.VoucherDatas.Number = this.VoucherNo 
            }
         }
    },
      }
    
     
    }
    </script>
    <style>
    .innerExPan {
  border-radius: 6px;
  margin: 24px;
  overflow-y: auto;
  pointer-events: auto;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  width: 100%;
  z-index: inherit;
  box-shadow: none !important;
}
#innerExPan > .v-expansion-panel-content__wrap {
  padding-top: 0px !important;
  padding-right: 0px !important;
  padding-bottom: 0px !important;
  padding-left: 0px !important;
}


    </style>
    